import { H4 } from 'ui/theme';

import { usePanelContext } from '../../contexts/Panel';
import { useTranslations } from '../../hooks/useTranslations';
import { PanelIntent } from '../../types';

export const testIds = {
  header: 'cl-panel-content-header',
};

const getPanelHeader = (intent: PanelIntent) => {
  switch (intent) {
    case PanelIntent.Browse:
      return 'header.browseImages';
    case PanelIntent.Edit:
      return 'header.changeImage';
    case PanelIntent.EditSelect:
      return 'header.changeImage';
    case PanelIntent.Insert:
      return 'header.insertImage';
    case PanelIntent.Select:
      return 'header.selectImage';
    case PanelIntent.ImportFromUrl:
      return 'header.importFromUrl';
    case PanelIntent.Upload:
      return 'header.uploadImage';
    default:
      return 'header.browseImages';
  }
};

export const PanelHeader = () => {
  const { t } = useTranslations();
  const { panelIntent } = usePanelContext();

  return <H4>{t(getPanelHeader(panelIntent))}</H4>;
};
